module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_7016.7e9b709e.png";